function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.73145 4.0408C4.45475 4.0408 4.23047 3.81651 4.23047 3.53981V0.500986C4.23047 0.224285 4.45475 0 4.73145 0C5.00816 0 5.23244 0.224285 5.23244 0.500986V3.53981C5.23244 3.81651 5.00816 4.0408 4.73145 4.0408Z",
  fill: "#FFCB0B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.2686 4.0408C10.9919 4.0408 10.7676 3.81651 10.7676 3.53981V0.500986C10.7676 0.224285 10.9919 0 11.2686 0C11.5453 0 11.7696 0.224285 11.7696 0.500986V3.53981C11.7696 3.81651 11.5453 4.0408 11.2686 4.0408Z",
  fill: "#FFCB0B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.759766 6.95044V13.863C0.759766 15.0414 1.71843 16.0001 2.89682 16.0001H13.1033C14.2817 16.0001 15.2404 15.0414 15.2404 13.863V6.95044H0.759766Z",
  fill: "#FFCB0B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.2403 5.94844V3.65649C15.2403 2.47811 14.2817 1.51944 13.1033 1.51944H12.7712V3.53982C12.7712 4.36858 12.097 5.04278 11.2682 5.04278C10.4395 5.04278 9.76528 4.36858 9.76528 3.53982V1.51941H6.23486V3.53979C6.23486 4.36855 5.56065 5.04275 4.7319 5.04275C3.90314 5.04275 3.22894 4.36855 3.22894 3.53979V1.51941H2.89682C1.71843 1.51941 0.759766 2.47808 0.759766 3.65646V5.94841H15.2403V5.94844Z",
  fill: "#FFCB0B"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));
function SvgCalendarAltYellowIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarAltYellowIcon);
export default __webpack_public_path__ + "static/media/calendar-alt-yellow-icon.d1adc012.svg";
export { ForwardRef as ReactComponent };